/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { FC } from 'react';
import { Button } from '../Button/Button';

import styles from './ErrorBlock.module.scss';

type Props = {
    message: string;
    showRefreshButton?: boolean;
};

export const ErrorBlock: FC<Props> = ({ message, showRefreshButton }) => {
    const refreshPage = () => {
        window.location.reload();
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.message}>{message}</div>
            {showRefreshButton && <Button small title="Refresh" onClick={refreshPage} />}
        </div>
    );
};
